import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from "@/router";
import { useUserStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

onMounted(async () => {
  await userStore.fetchUser();

  if (user.value.id) {
    return router.push("/dashboard");
  }

  return router.push("/login");
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withCtx(() => [
          _createTextVNode("Login")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, { to: "/signup" }, {
        default: _withCtx(() => [
          _createTextVNode("Signup")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})